import { ApiToken } from '../services/authApi';
import { InferenceApiKey } from '../services/inferenceApi';

export interface KeyRow {
  token: ApiToken;
  settings: InferenceApiKey | null;
}

// joinKeys pairs each auth-service token with its inference-side settings row
// (matched on the displayed key prefix). Tokens with no mirrored settings row
// yet (just created) get settings: null.
export function joinKeys(tokens: ApiToken[], settings: InferenceApiKey[]): KeyRow[] {
  const byPrefix = new Map<string, InferenceApiKey>();
  for (const s of settings) byPrefix.set(s.key_prefix, s);
  return tokens.map((token) => ({
    token,
    settings: (token.prefix && byPrefix.get(token.prefix)) || null,
  }));
}
